<template>
    <table class="kgr-table kgr-table--striped kgr-table--block kgr-row">
        <thead>
            <tr class="kgr-table__row">
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Name') }}
                </th>
                <th
                    v-if="!isMemberContext"
                    class="kgr-table__cell kgr-table__cell--headline"
                >
                    {{ $t('Mitglied') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Mitarbeiter') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Zahlungsmethode') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Datum') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Anzahl') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('lädt Guthaben auf') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Einzelpreis') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('Summe') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="memberClubFee in memberClubFees"
                :key="memberClubFee.id"
                class="kgr-table_row"
            >
                <td class="kgr-table__cell">
                    {{ memberClubFee.name }}
                </td>
                <td
                    v-if="!isMemberContext"
                    class="kgr-table__cell"
                >
                    {{ memberClubFee.member.name }}
                </td>
                <td class="kgr-table__cell">
                    {{ memberClubFee.creator.name }}
                </td>
                <td class="kgr-table__cell">
                    {{ memberClubFee.paymentMethod }}
                </td>
                <td class="kgr-table__cell">
                    {{ formatDate(memberClubFee.createdAt) }}
                </td>
                <td class="kgr-table__cell">
                    {{ formatQuantityFactor(memberClubFee.quantityFactor) }}
                </td>
                <td class="kgr-table__cell">
                    <div
                        v-if="memberClubFee.chargeCredit"
                        class="icon-check"
                    ></div>
                </td>
                <td class="kgr-table__cell">
                    <kgr-price
                        :price="memberClubFee.pricePerTime"
                        :with-vat="true"
                    />
                </td>
                <td class="kgr-table__cell">
                    <kgr-price
                        :price="memberClubFee.pricePerTime"
                        :quantity-factor="memberClubFee.quantityFactor"
                        :with-vat="false"
                    />
                </td>
            </tr>
            <tr
                v-if="!hasMemberClubFees"
                class="kgr-table__row"
            >
                <td
                    :colspan="isMemberContext ? 8 : 9"
                    class="kgr-table__cell"
                >
                    --
                </td>
            </tr>
            <tr
                v-if="hasMemberClubFees"
                class="kgr-table__row"
            >
                <td
                    :colspan="emptyColSpan"
                    class="kgr-table__cell"
                ></td>
                <td class="kgr-table__cell text-right bold">
                    {{ $t('Summe Netto') }}
                </td>
                <td class="kgr-table__cell bold">
                    <kgr-price
                        :price="summedPrices.net"
                        :from-number="true"
                    />
                </td>
            </tr>
            <tr
                v-if="hasMemberClubFees"
                class="kgr-table__row"
            >
                <td
                    :colspan="emptyColSpan"
                    class="kgr-table__cell"
                ></td>
                <td class="kgr-table__cell text-right bold">
                    {{ $t('Summe Brutto') }}
                </td>
                <td class="kgr-table__cell bold">
                    <kgr-price
                        :price="summedPrices.gross"
                        :from-number="true"
                    />
                </td>
            </tr>
            <tr
                v-if="hasMemberClubFees"
                class="kgr-table__row"
            >
                <td
                    :colspan="emptyColSpan"
                    class="kgr-table__cell"
                ></td>
                <td class="kgr-table__cell text-right bold">
                    {{ $t('Darin enthaltene MwSt.') }}
                </td>
                <td class="kgr-table__cell bold">
                    <kgr-price
                        :price="summedPrices.vat"
                        :from-number="true"
                    />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import PricePerTimeOutput from './PricePerTimeOutput';
import moment from 'moment';

export default {
    components: {
        'kgr-price': PricePerTimeOutput,
    },
    props: {
        memberClubFees: {
            type: Array,
            required: false,
            default: null,
        },
        isMemberContext: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        emptyColSpan() {
            if (this.isMemberContext) {
                return 6;
            }
            return 7;
        },
        hasMemberClubFees() {
            return this.memberClubFees !== null && this.memberClubFees.length > 0;
        },
        summedPrices() {
            const prices = {
                gross: { amount: null, currency: null },
                net: { amount: null, currency: null },
                vat: { amount: null, currency: null },
            };
            if (this.hasMemberClubFees) {
                const currency = this.memberClubFees[0].pricePerTime.currency;
                prices.gross.currency = currency;
                prices.net.currency = currency;
                prices.vat.currency = currency;
                this.memberClubFees.forEach((memberClubFee) => {
                    const quantity = memberClubFee.quantityFactor.numerator / memberClubFee.quantityFactor.denominator;
                    prices.gross.amount += memberClubFee.pricePerTime.gross.numerator / memberClubFee.pricePerTime.gross.denominator * quantity;
                    prices.net.amount += memberClubFee.pricePerTime.net.numerator / memberClubFee.pricePerTime.net.denominator * quantity;
                });
                prices.vat.amount = prices.gross.amount - prices.net.amount;
            }
            return prices;
        },
    },
    methods: {
        formatQuantityFactor(quantityFactor) {
            return quantityFactor.numerator / quantityFactor.denominator;
        },
        formatDate(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm:ss');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.bold {
    font-weight: var(--kgr-font-weight-bold);
}
.text-right {
    text-align: right;
}
</style>
